export const veoKooperation = {
  "id": "veo-kooperation-2025",
  "title": "Rugby-Bundesliga setzt auf Videoanalyse: Kooperation mit VEO gestartet",
  "slug": "rugby-bundesliga-videoanalyse-veo-kooperation",
  "publishedAt": "2025-09-22T11:00:00Z",
  "author": "Rugby Bundesliga Redaktion",
  "language": "de",
  "readTime": "4 min",
  "tags": ["Rugby", "Bundesliga", "VEO", "Videoanalyse", "Technologie", "Professionalisierung"],
  "excerpt": "Die Rugby-Bundesliga startet Kooperation mit VEO für moderne Videoanalyse und erweitert das Angebot für Vereine und Fans.",
  "img": "/images/veo-kooperation-2025.png",
  "blocks": [
    {
      "type": "paragraph",
      "content": "Die Rugby-Bundesliga geht einen weiteren Schritt in Richtung Professionalisierung. Ab sofort arbeitet die Liga mit dem dänischen Unternehmen VEO zusammen, das auf innovative Kameratechnologie für den Sport spezialisiert ist. Ziel ist es, die Videoanalyse in den Vereinen auf ein neues Niveau zu heben und zugleich die Attraktivität der Liga weiter zu steigern."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Umfangreiches Videomaterial für alle Erstligavereine"
    },
    {
      "type": "paragraph",
      "content": "Dank der Kooperation werden alle Erstligaspiele aufgezeichnet und im internen Ligenaustausch hochgeladen. So haben die Vereine künftig Zugriff auf umfangreiches Videomaterial ihrer Gegner und können dieses direkt für ihre Analysen nutzen. Damit eröffnen sich für Trainer und Spieler neue Möglichkeiten, sich gezielt auf anstehende Begegnungen vorzubereiten und die eigene Leistung kontinuierlich zu verbessern."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Ausweitung auf die 2. Bundesliga"
    },
    {
      "type": "paragraph",
      "content": "Ein weiterer Schritt betrifft die 2. Bundesliga: Ab der kommenden Saison wird auch hier der Upload von Spielvideos verpflichtend. Damit soll die Basis für eine noch breitere Videoanalyse geschaffen und die Entwicklung der Teams in beiden Ligen gefördert werden."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Perspektive für Fans: Spiele auf YouTube"
    },
    {
      "type": "paragraph",
      "content": "Doch nicht nur die Vereine profitieren. Perspektivisch sollen die Spiele auch auf YouTube für die Fans verfügbar gemacht werden. So erhält die Rugby-Community die Möglichkeit, Spiele nachzuverfolgen, Höhepunkte erneut zu erleben und die Bundesliga noch enger zu begleiten."
    },
    {
      "type": "paragraph",
      "content": "Mit der Kooperation mit VEO schafft die Rugby-Bundesliga die Grundlage für eine moderne und professionelle Spielanalyse – und bietet zugleich Fans und Vereinen einen echten Mehrwert."
    },
    {
      "type": "callout",
      "variant": "success",
      "title": "Moderne Technologie für die Rugby-Bundesliga",
      "content": "Die Partnerschaft mit VEO bringt professionelle Videoanalyse-Tools in die deutsche Rugby-Landschaft und stärkt sowohl die taktische Entwicklung der Teams als auch das Fan-Erlebnis durch bessere Zugänglichkeit zu Spielmaterial."
    }
  ]
}
